<template>
  <b-modal v-model="showModal">
    <div slot="modal-title">
      ค้นหางาน
    </div>
    <section>

      <div class="form-group">
        <label for="keyword">คำค้น</label>
        <input type="text"
               class="form-control"
               id="keyword"
               v-model="keyword"
               placeholder="กรอกตำแหน่งงาน หรือรายละเอียดงาน">
      </div>

      <div class="row no-gutters">
        <div class="col-lg-6 col-12 pr-lg-2 mt-2">
          <label for="addressProvince">จังหวัด</label>
          <select v-model="selectedAddressProvinceId"
                  class="form-control"
                  id="addressProvince"
                  name="addressProvince">
            <option :value="null">{{ $t('message.booking.contact_step.set_province') }}</option>
            <option :value="addressProvince.id" v-for="addressProvince, index in sortedProvinces">
              {{ addressProvince | multiLangName }}
            </option>
          </select>
        </div>
        <div class="col-lg-6 col-12 pl-lg-2 mt-2">
          <label for="district">เขต/อำเภอ</label>
          <select v-model="selectedDistrictId"
                  class="form-control"
                  id="district"
                  name="district">
            <option :value="null">{{ $t('message.booking.contact_step.set_district') }}</option>
            <option :value="district.id" v-for="district, index in sortedDistricts">
              {{ district | multiLangName }}
            </option>
          </select>
        </div>
      </div>
      <div class="mt-3">
        <div class="pb-3">
          <label>รายได้ต่อเดือน (โดยประมาณ)</label>
        </div>
        <div class="py-4 px-3">
          <vue-slider
            v-model="salaryRange"
            :min="0"
            :max="30000"
            :marks="salaryMarks"
            :tooltip="'always'"/>
        </div>
      </div>
      <div class="mt-3 row no-gutters">
        <div class="col-12">
          <button class="btn btn-info btn-block" @click="searchJobPosts()">ค้นหา</button>
        </div>
      </div>
    </section>
    <div slot="modal-footer" class="w-100">
      <b-btn class="float-right" variant="secondary" @click="showModal = false">
        {{ $t('message.button.close') }}
      </b-btn>
    </div>
  </b-modal>
</template>

<script>
  import { mapState } from 'vuex'
  import VueSlider from 'vue-slider-component'
  import 'vue-slider-component/theme/antd.css'

  export default {
    components: {
      VueSlider
    },
    data () {
      return {
        showModal: false,
        keyword: null,
        selectedAddressProvinceId: null,
        selectedDistrictId: null,
        salaryRange: [0, 30000],
        salaryMarks: {
          '0': {
            'label': '0'
          },
          '15000': {
            'label': '15,000'
          },
          '30000': {
            'label': '30,000'
          }
        }
      }
    },
    computed: {
      ...mapState('addressProvince', ['addressProvinces', 'districts']),
      sortedProvinces () {
        return this._.orderBy(this.addressProvinces, [this.sortBy], ['asc'])
      },
      sortedDistricts () {
        return this._.orderBy(this.districts, [this.sortBy], ['asc'])
      }
    },
    watch: {
      selectedAddressProvinceId () {
        if (this.selectedAddressProvinceId) {
          this.selectedDistrictId = null
          this.fetchDistricts(this.selectedAddressProvinceId)
        }
      }
    },
    methods: {
      searchJobPosts () {
        const searchParams = {
          keyword: this.keyword,
          province_id: this.selectedAddressProvinceId,
          district_id: this.selectedDistrictId,
          min_salary: this.salaryRange[0],
          max_salary: this.salaryRange[1]
        }
        this.$emit('searchJobPosts', searchParams)
      },
      displayModal (status) {
        this.showModal = status
      },
      fetchDistricts (provinceId) {
        if (provinceId) {
          const queryData = {
            province_id: provinceId
          }
          this.$store.dispatch('addressProvince/LOAD_DISTRICTS', queryData)
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/jobPost/SearchModal.vue